import { isAdmin, isMultirole } from '@/authProvider'
import { Admin } from './Admin'
import { MultiRolePartner } from './MultiRolePartner'

export const PartnersSelect = () => {
  if (isMultirole() && !isAdmin()) {
    return <MultiRolePartner />
  }

  return <Admin />
}
